import { createSelector } from 'reselect';

import { selectTargetPlatform } from '@pressreader/appcore';
import { selectGetConfigValue } from '@pressreader/config';
import { selectIsEmbeddedModeEnabled } from '@pressreader/sponsorship-core';
import { TargetPlatform } from '@pressreader/types';

export const selectCommentsEnabled = createSelector(
    selectGetConfigValue,
    selectTargetPlatform,
    selectIsEmbeddedModeEnabled,
    (getConfigValue, targetPlatform, isEmbeddedModeEnabled) => {
        const isPervasive = targetPlatform === TargetPlatform.Pervasive;
        const isVoyager = targetPlatform === TargetPlatform.Voyager;

        const commentsEnabledByPlatform = !isPervasive && !isVoyager;
        const commentsEnabledByConfig =
            getConfigValue<boolean>('UI.Comments.enable', true) && (getConfigValue<boolean>('features.comment.enabled') ?? true);

        return !isEmbeddedModeEnabled && commentsEnabledByPlatform && commentsEnabledByConfig;
    },
);
